import { render } from "./InfoGuide.vue?vue&type=template&id=5e6dfbb9&scoped=true"
import script from "./InfoGuide.vue?vue&type=script&lang=js"
export * from "./InfoGuide.vue?vue&type=script&lang=js"

import "./InfoGuide.vue?vue&type=style&index=0&id=5e6dfbb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6dfbb9"]])

export default __exports__